<template>
  <footer class="noprint">
    <div class="container flex align-items-center">
      <div class="brand flex-1">
        <img :src="isDarkMode ? '/img/mark-dark.svg' : '/img/mark-light.svg'" />
      </div>

      <div class="meta flex-1">
        <p>
          <a :href="mailtoLink" target="_blank"> Report an issue </a>
        </p>
        <span v-if="buildInfo.GIT_COMMIT" class="branch">
          Build: {{ buildInfo.GIT_COMMIT }}
        </span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import type { BuildInfo } from "@/injectionKeys";
import type { PropType } from "vue";
import { useSettingsStore } from "@/store";

const props = defineProps({
  buildInfo: {
    type: Object as PropType<BuildInfo>,
    default: () => ({
      BUILD_ID: null
    })
  }
});

const { buildInfo } = props;
const { isDarkMode } = useSettingsStore();
const subject = `Issue on build ${buildInfo.GIT_COMMIT ?? "Unknown"}:`;
const mailtoLink = `mailto:SGSupport@Halliburton.com?subject=${encodeURIComponent(subject)}`;
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  border-top: 1px solid var(--gray-400);
  min-height: 80px;
  transition: all 0.2s ease-in-out;

  .brand {
    img {
      max-height: 36px;
    }
  }
  .meta {
    font-size: 12px;
    text-align: right;
  }
  .bigger {
    font-size: 10;
    font-weight: 600;
  }

  .build {
    font-weight: 300;
  }

  .branch {
    font-style: italic;
  }
}
</style>
